import { Grid, MenuItem } from '@mui/material';
import { CustomSelect, CustomTextField, HeaderFilterBox } from '../../../common';
import {
  SOURCE_TYPE_LABELS,
  SUPPLY_ORDER_STATUS_LABELS,
} from '../constants/supplyOrdersConstants';
import { getProviderDisplayLabel } from '../utils/supplyOrdersUtils';

const SupplyOrdersFilters = ({
  filters,
  warehouses = [],
  providers = [],
  onFilterChange,
  onSelectChange,
}) => {
  return (
    <HeaderFilterBox variant="twoRows">
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <CustomTextField
            label="Buscar"
            name="query"
            value={filters.query}
            onChange={onFilterChange}
            placeholder="Código, proveedor, depósito..."
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomSelect
            label="Estado"
            name="status"
            value={filters.status}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los estados</MenuItem>
            {Object.entries(SUPPLY_ORDER_STATUS_LABELS).map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomSelect
            label="Tipo de origen"
            name="source_type"
            value={filters.source_type}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los orígenes</MenuItem>
            {Object.entries(SOURCE_TYPE_LABELS).map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomSelect
            label="Proveedor"
            name="uuid_provider_legal_entity"
            value={filters.uuid_provider_legal_entity}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los proveedores</MenuItem>
            {providers.map((provider) => (
              <MenuItem key={provider.uuid} value={provider.uuid}>
                {getProviderDisplayLabel(provider)}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomSelect
            label="Depósito destino"
            name="uuid_destination_warehouse"
            value={filters.uuid_destination_warehouse}
            onChange={onSelectChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">Todos los depósitos destino</MenuItem>
            {warehouses.map((warehouse) => (
              <MenuItem key={warehouse.uuid} value={warehouse.uuid}>
                {warehouse.name || warehouse.code}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} md={1.5}>
          <CustomTextField
            label="Desde"
            name="date_from"
            type="date"
            value={filters.date_from}
            onChange={onFilterChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={1.5}>
          <CustomTextField
            label="Hasta"
            name="date_to"
            type="date"
            value={filters.date_to}
            onChange={onFilterChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
      </Grid>
    </HeaderFilterBox>
  );
};

export default SupplyOrdersFilters;
